import React, { useState } from "react";
import API from "../utils/api";
import { useNavigate } from "react-router-dom";
import FlashMessage from "./FlashMessage";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [flashMessage, setFlashMessage] = useState("");
  const [flashType, setFlashType] = useState("success");
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await API.post("/auth/forgot-password", { email });

      if (res.status === 200) {
        setFlashType("success");
        setFlashMessage("Password reset link send to email");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
    } catch (err) {
      setFlashType("error");
      setFlashMessage("Error sending reset link");
      // setMsg(err.response?.data?.message || "Error sending reset link");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <FlashMessage
        message={flashMessage}
        type={flashType}
        duration={3000}
        onClose={() => setFlashMessage("")}
      />
      <div className="login-card">
        <h2>Forgot Password</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary btn-block"
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
